<template>
  <div class="hello" @click="(isShowSelect = false), (isShowMoney = false)">
    <my-header :activeIndex="6" />
    <div class="pay-banner"></div>
    <div class="pay-w e_pay_wrap">
      <div class="clearfix pay-main">
        <div class="clearfix pay-main-w">
          <div class="fl pay-mode e_pay_mode">
            <ul class="clearfix pay-mode-main">
              <li
                class="fl"
                v-for="(item, index) in pay_name_list"
                :key="index"
              >
                <a
                  :class="[
                    pay_active == item.id
                      ? 'block pay-public cur'
                      : 'block pay-public',
                  ]"
                  @click="handleClickPayType(item.id)"
                  >{{ item.name }}</a
                >
              </li>
            </ul>
          </div>
          <div class="pay-content e_pay_content">
            <div style="display: flex; padding-bottom: 22px">
              <label class="pay-title" style="line-height: 38px"
                >可售卖游戏：</label
              >
              <div class="por">
                <div
                  class="pay-select e_product"
                  :class="[isShowSelect ? 'cur' : '']"
                >
                  <span v-on:click.stop="arrowDown" class="pay-select-arrow"
                    >&#9660;</span
                  >
                  <input
                    v-on:click.stop="arrowDown"
                    type="text"
                    class="pay-select-selected e_selected"
                    readonly="readonly"
                    :value="unitName"
                    sucmsg="&nbsp;"
                  />
                  <div
                    class="clearfix pay-select-options-w hide e_options"
                    v-show="isShowSelect"
                  >
                    <h2 class="pay-select-options">
                      <a
                        class="fl"
                        :class="[index == 0 ? 'first' : '']"
                        v-for="(item, index) in productInfo"
                        @click.stop="select(item.product, index)"
                        :key="index"
                      >
                        {{ item.product }}
                      </a>
                    </h2>
                  </div>
                </div>
              </div>
            </div>
            <div style="display: flex; padding-bottom: 22px">
              <label class="pay-title" style="line-height: 38px"
                >输入账号：</label
              >
              <div class="por">
                <div
                  class="pay-select e_product"
                  :class="[isShowSelect ? 'cur' : '']"
                >
                  <input
                    type="text"
                    class="pay-select-selected e_selected"
                    :v-model="account"
                    sucmsg="&nbsp;"
                  />
                </div>
              </div>
            </div>
            <div style="display: flex; padding-bottom: 22px">
              <label class="pay-title" style="line-height: 38px"
                >购买商品：</label
              >
              <div class="por">
                <div
                  class="pay-select e_product"
                  :class="[isShowMoney ? 'cur' : '']"
                >
                  <span class="pay-select-arrow" v-on:click.stop="arrowMoney"
                    >&#9660;</span
                  >
                  <input
                    v-on:click.stop="arrowMoney"
                    type="text"
                    class="pay-select-selected e_selected"
                    readonly="readonly"
                    :value="
                      unitMoney == ''
                        ? '请选择商品'
                        : unitMoney * 10 + '仙玉(人民币' + unitMoney + '元)'
                    "
                    sucmsg="&nbsp;"
                  />
                  <div
                    class="clearfix pay-select-options-w hide e_options"
                    v-show="isShowMoney"
                  >
                    <h2 class="pay-select-options">
                      <a
                        class="fl"
                        :class="[item_money == 0 ? 'first' : '']"
                        v-for="(item_money, index_money) in money_list"
                        @click.stop="select_money(item_money)"
                        :key="index_money"
                      >
                        {{ item_money * 10 }}仙玉(人民币{{ item_money }}元)
                      </a>
                    </h2>
                  </div>
                </div>
              </div>
            </div>
            <div style="display: flex; padding-bottom: 22px">
              <label class="pay-title" style="line-height: 38px"
                >充值金额：</label
              >
              <span
                style="line-height: 38px; font-size: 20px; font-weight: bold"
              >
                {{ unitMoney == "" ? "0" : unitMoney }} 元</span
              >
            </div>
            <div style="display: flex">
              <label class="pay-title" style="line-height: 38px" /><input
                type="submit"
                class="block pay-submit e_submit"
                style="width: 120px"
                value="确定充值"
                @click="handleOpenText"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isPay" class="fang" @click="isPay = false">
      <img class="dialog" src="../assets/pay.jpg" />
    </div>
    <my-footer />
    <my-top />
  </div>
</template>
<script>
import MyFooter from "./MyFooter.vue";
import MyHeader from "./MyHeader.vue";
import MyTop from "./MyTop.vue";
export default {
  name: "pay",
  data() {
    return {
      isPay: false,
      isShowSelect: false,
      isShowMoney: false,
      unitName: "请选择游戏",
      unitMoney: "",
      pay_active: 4,
      account: "",
      pay_name_list: [
        // {
        //   id: 1,
        //   name: '银行卡充值'
        // },
        //{
        // id: 1,
        //  name: '支付宝扫码充值'
        //  },
        // {
        //  id: 2,
        //   name: '微信扫码充值'
        //  },
        // {
        //   id: 3,
        //   name: "支付宝充值",
        // },
        {
          id: 4,
          name: "微信充值",
        },
      ],
      money_list: [
        10, 12, 30, 64, 98, 128, 168, 198, 328, 648, 998, 1998, 2998,
      ],
      productInfo: [
        {
          pid: "p-p7",
          product: "守护者之森",
          phone: "021-61174567",
          email: "tzjkefu@iwgame.com",
          url: "http://tzj2.iwgame.com/",
          murl: "http://tzj2.iwgame.com/",
          downUrl: "http://tzj2.iwgame.com/",
          logo: "http://tzj2.iwgame.com/images/v3/common/logo.png",
          carousel: "https://www.iwgame.com/js/poster_js/209.js",
          productPosterJs: "https://www.iwgame.com/js/poster_js/210.js",
          passportLoginBgJs: "https://www.iwgame.com/js/poster_js/211.js",
        },
        {
          pid: "p-p1",
          product: "琴剑封魔录",
          phone: "021-61174567",
          email: "kefu@shumenol.com",
          url: "http://www.shumenol.com/",
          murl: "http://m.shumenol.com/",
          downUrl: "http://www.shumenol.com/html/download/",
        },
        {
          pid: "p-p1.5",
          product: "疯狂超赛战士",
          phone: "021-61174567",
          email: "kf@zuixiaoyao.com",
          url: "http://www.zuixiaoyao.com/",
          murl: "http://m.zuixiaoyao.com/",
          downUrl: "http://www.zuixiaoyao.com/download.htm",
        },
        {
          pid: "p-p1.5",
          product: "天之禁",
          phone: "021-61174567",
          email: "kf@zuixiaoyao.com",
          url: "http://www.zuixiaoyao.com/",
          murl: "http://m.zuixiaoyao.com/",
          downUrl: "http://www.zuixiaoyao.com/download.htm",
        },
      ],
    };
  },
  components: {
    "my-footer": MyFooter,
    "my-header": MyHeader,
    "my-top": MyTop,
  },
  methods: {
    handleClickPayType(id) {
      this.pay_active = id;
    },
    arrowDown() {
      this.isShowSelect = !this.isShowSelect;
    },
    arrowMoney() {
      this.isShowMoney = !this.isShowMoney;
    },
    select(name) {
      this.isShowSelect = false;
      this.unitName = name;
    },
    select_money(name) {
      this.isShowMoney = false;
      this.unitMoney = name;
    },
    handleOpenText() {
      this.isPay = true;
    },
  },
};
</script>
<style scoped>
.hello {
  background: url(../assets/game/bg.png);
  background-size: cover;
  background-repeat: round;
  background-position: center center;
}
.dropdown-content {
  position: absolute;
  visibility: hidden;
  opacity: 0;
  transition: all 0.6s ease-in-out;
}

.dropdown-menu {
  margin-top: 4px;
  padding: 10px 8px 15px;
  color: white;
  background-color: #000;
  border-radius: 4px;
}

.menuItem {
  width: 100%;
  white-space: nowrap;
  padding: 10px 16px;
  font-size: 16px;
  color: white;
  cursor: pointer;
  border-radius: 4px;
}

.menuItem :hover {
  background-color: #ccc;
}

ul,
li {
  list-style: none;
}

.logo_game {
  height: 50%;
  position: relative;
  top: 39%;
  left: 15px;
}
.fang {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.5);
  cursor: pointer;
}
.dialog {
  position: absolute;
  width: 20%;
  /* height: 100%; */
  top: 25%;
  left: 40%;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/pay.vue